import React from 'react';
import { motion } from 'framer-motion';
import { FileSpreadsheet, ArrowRight, LayoutDashboard, Network } from 'lucide-react';
export function CSVSection() {
  return <section className="py-32 bg-secondary/30 border-y border-white/5 overflow-hidden" data-id="element-57">
      <div className="max-w-7xl mx-auto px-6" data-id="element-58">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-59">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-6" data-id="element-60">
            Live in four minutes.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-textSecondary" data-id="element-61">
            Dump your CSVs. We organize everything. Then we integrate your tech
            — so you never touch a CSV again.
          </motion.p>
        </div>

        <div className="relative max-w-4xl mx-auto" data-id="element-62">
          {/* Connecting Line */}
          <div className="absolute top-1/2 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-accent/50 to-transparent -translate-y-1/2 hidden md:block" data-id="element-63" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-64">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-card border border-white/5 rounded-2xl p-8 text-center flex flex-col items-center" data-id="element-65">
              <div className="w-16 h-16 bg-white/5 rounded-full flex items-center justify-center mb-6" data-id="element-66">
                <FileSpreadsheet className="text-white" size={32} data-id="element-67" />
              </div>
              <h3 className="text-xl font-medium mb-2" data-id="element-68">Dump your CSVs</h3>
              <p className="text-sm text-textSecondary" data-id="element-69">
                Drop in your spreadsheets. That's it.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-card border border-accent/20 rounded-2xl p-8 text-center flex flex-col items-center accent-glow relative" data-id="element-70">
              <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mb-6" data-id="element-71">
                <LayoutDashboard className="text-accent" size={32} data-id="element-72" />
              </div>
              <h3 className="text-xl font-medium mb-2" data-id="element-73">
                We organize everything
              </h3>
              <p className="text-sm text-textSecondary" data-id="element-74">
                Four minutes from start to finish.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="bg-card border border-white/5 rounded-2xl p-8 text-center flex flex-col items-center" data-id="element-75">
              <div className="w-16 h-16 bg-white/5 rounded-full flex items-center justify-center mb-6" data-id="element-76">
                <Network className="text-white" size={32} data-id="element-77" />
              </div>
              <h3 className="text-xl font-medium mb-2" data-id="element-78">
                We integrate your tech
              </h3>
              <p className="text-sm text-textSecondary" data-id="element-79">
                No more CSVs. Everything updates itself.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}